import { CUSTOMER_TYPE } from "../constants";

const customerReducer = (state = {
   page: 1,
   page_size: 0,
   total: 0,
   customers: []
}, action) => {
   switch (action.type) {
      case CUSTOMER_TYPE.FETCHS:
         return {
            ...state,
            ...action.payload
         };
      case CUSTOMER_TYPE.LOAD_COMMENTS:
         return {
            ...state,
            customers: state.customers.map(m => {
               const { psid, campaign_id, data } = action.payload;
               if (m.psid === psid && m.campaign_id === campaign_id) {
                  return {
                     ...m,
                     messages: data
                  }
               }
               return m;
            })
         }
      case CUSTOMER_TYPE.LOAD_SHOW_MORE_COMMENTS:
         return {
            ...state,
            customers: state.customers.map(m => {
               const { psid, campaign_id, data } = action.payload;
               if (m.psid === psid && m.campaign_id === campaign_id) {
                  return {
                     ...m,
                     messages: {
                        ...data,
                        comments: m?.messages?.comments ? [...m.messages.comments, ...data.comments] : data.comments
                     }
                  }
               }
               return m;
            })
         }
      case CUSTOMER_TYPE.ORDER_HANDLING_STATUS:
      case CUSTOMER_TYPE.ORDER_HANDLE:
         return {
            ...state,
            customers: state.customers.map(m => {
               const { id } = action.payload;
               if (m.id === id) {
                  return {
                     ...m,
                     ...action.payload
                  };
               }
               return m;
            })
         }
      default:
         return state;
   }
};

export default customerReducer